import React, { useEffect } from 'react';

import { WizardStep } from '@/components/postgrid/wizard';

interface ContactReviewStepProps {
  wizardData?: Record<string, any>;
  markStepComplete?: (isValid: boolean) => void;
}

export const ContactReviewStep: React.FC<ContactReviewStepProps> = ({
  wizardData = {},
  markStepComplete,
}) => {
  useEffect(() => {
    // Always complete (validation happened in previous steps)
    markStepComplete?.(true);
  }, [markStepComplete]);

  const {
    first_name,
    last_name,
    company_name,
    email,
    phone_number,
    address_line1,
    address_line2,
    city,
    province_or_state,
    postal_or_zip,
    country,
    notes,
  } = wizardData;

  return (
    <WizardStep
      title="Review & Submit"
      description="Make sure everything looks correct before creating the contact."
    >
      <div className="space-y-6">
        <div className="border border-gray-200 rounded-lg p-6">
          <h4 className="font-medium text-gray-900 mb-4">Identity</h4>
          <p className="text-sm text-gray-700">
            {first_name || last_name ? (
              <span>
                {first_name} {last_name}
              </span>
            ) : (
              '—'
            )}
          </p>
          {company_name && (
            <p className="text-sm text-gray-700 mt-1">{company_name}</p>
          )}
        </div>

        <div className="border border-gray-200 rounded-lg p-6">
          <h4 className="font-medium text-gray-900 mb-4">Contact</h4>
          <p className="text-sm text-gray-700">Email: {email || '—'}</p>
          <p className="text-sm text-gray-700">Phone: {phone_number || '—'}</p>
        </div>

        <div className="border border-gray-200 rounded-lg p-6">
          <h4 className="font-medium text-gray-900 mb-4">Address</h4>
          <p className="text-sm text-gray-700">
            {address_line1}
            {address_line2 && <> , {address_line2}</>}
          </p>
          <p className="text-sm text-gray-700">
            {city}, {province_or_state} {postal_or_zip}
          </p>
          <p className="text-sm text-gray-700">{country}</p>
        </div>

        {notes && (
          <div className="border border-gray-200 rounded-lg p-6">
            <h4 className="font-medium text-gray-900 mb-4">Notes</h4>
            <p className="text-sm text-gray-700 whitespace-pre-line">{notes}</p>
          </div>
        )}

        <div className="text-center mt-6">
          <p className="text-sm text-gray-500">
            Click &quot;Submit&quot; to create the contact.
          </p>
        </div>
      </div>
    </WizardStep>
  );
};
